<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" :filters="false"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="btns">
            <el-upload :show-file-list="false" :before-upload="handleImport" accept=".xls,.xlsx" action="">
                <el-button size="mini" type="primary" icon="el-icon-upload2">
                    导入
                </el-button>
            </el-upload>
        </template>
        <template slot="columns">
            <el-table-column label="序号" align="center" type="index" width="100"></el-table-column>
            <el-table-column label="设备、配件" align="center" prop="category"></el-table-column>
            <el-table-column label="设备英文名称" align="center" prop="deviceEnName"></el-table-column>
            <el-table-column label="设备英文类型" align="center" prop="deviceEnType"></el-table-column>
            <el-table-column label="设备中文名称" align="center" prop="deviceName"></el-table-column>
            <el-table-column label="产品、设备类型" align="center" prop="deviceType"></el-table-column>
            <el-table-column label="组件id" align="center" prop="moduleId"></el-table-column>
            <el-table-column label="终端类型" align="center" prop="productType"></el-table-column>
            <el-table-column label="SYSID" align="center" prop="sysId"></el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { getDeviceBaseInfoList, importDeviceBaseInfo } from "@/api/device/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {}
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            getDeviceBaseInfoList({ ...this.query }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records || [];
                    this.total = result.total || 0;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleImport(file) {
            importDeviceBaseInfo(file).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success("导入成功");
                    this.search();
                } else {
                    this.$message.error(message);
                }
            });
            return false;
        }
    },
};
</script>
